import { graphql } from "../generated/gql";

export const SearchLineWithLanguage = graphql(
  `
    query SearchLineWithLanguage(
      $filter: SearchableLinesFilterInput!
      $limit: Int!
    ) {
      searchAuthorizedLines(filter: $filter, limit: $limit) {
        items {
          ...SearchLineDetails
        }
      }
    }
  `
);
